// Ask AI sheet (snippets/ym-ask.liquid): posts a question with the page's product data and shows
// the answer. Anything but an answer leads to the Judge.me question form, opened by ym-reviews.
if (!customElements.get('ym-ask-sheet')) {
  const SOURCE_PREFIX = 'From this page: ';

  // A chart cell holds inches and centimetres, one of them hidden. Inches are enough here.
  const chartCell = (cell) => {
    const copy = cell.cloneNode(true);
    copy.querySelectorAll('.ym-cm').forEach((unit) => unit.remove());
    return copy.textContent.trim();
  };

  // Closed accordions have no rendered text, so read the markup and keep its line breaks.
  const readable = (element) => {
    if (!element) return '';
    const lines = [...element.querySelectorAll('li, p')].map((line) => line.textContent.trim());
    return (lines.filter(Boolean).join('\n') || element.textContent.trim()).slice(0, 2500);
  };

  customElements.define(
    'ym-ask-sheet',
    class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.result = this.querySelector('[data-ym-ask-result]');
        this.text = this.querySelector('[data-ym-ask-text]');
        this.source = this.querySelector('[data-ym-ask-source]');
        this.contact = this.querySelector('[data-ym-ask-contact]');
        this.team = this.querySelector('[data-ym-ask-team]');
        this.form = this.querySelector('[data-ym-ask-form]');
        this.send = this.form.querySelector('[type="submit"]');
        this.input = this.form.elements.question;

        this.addEventListener('click', (event) => {
          const chip = event.target.closest('[data-ym-ask-chip]');
          if (chip) this.ask(chip.textContent.trim());
          if (event.target.closest('[data-ym-ask-close]') || event.target === this.dialog) this.dialog.close();
          if (event.target.closest('[data-ym-ask-team]')) this.openTeamForm();
        });
        this.form.addEventListener('submit', (event) => {
          event.preventDefault();
          const question = this.input.value.trim();
          if (question) this.ask(question);
        });
      }

      open() {
        this.dialog.showModal();
      }

      context() {
        const data = JSON.parse(this.querySelector('[data-ym-ask-context]').textContent);
        const items = (selector, part) =>
          [...document.querySelectorAll(selector)].map((item) => ({
            title: item.querySelector('summary').textContent.trim(),
            text: readable(item.querySelector(part)),
          }));

        data.arrives_text = document.querySelector('.ym-deliv__text')?.innerText.trim() ?? '';
        data.today = new Date().toDateString();
        data.sections = items('.ym-acc__item', '.ym-acc__a');
        data.faq = items('.ym-faq__item', '.ym-faq__a');
        data.size_chart = [...document.querySelectorAll('.ym-sc__grid')]
          .map((row) => [...row.children].map(chartCell).join(' | '))
          .join('\n')
          .slice(0, 2500);
        return data;
      }

      show({ text, source = '', contact = false, team = true, label = 'Ask our team instead' }) {
        this.result.hidden = false;
        this.text.textContent = text;
        this.source.textContent = source;
        this.source.hidden = !source;
        this.contact.hidden = !contact;
        this.team.hidden = !team;
        this.team.textContent = label;
      }

      async ask(question) {
        this.question = question;
        this.input.value = '';
        this.send.disabled = true;
        this.show({ text: 'Checking the product details…', team: false });

        const noAnswer = (text) => ({
          text: text || "I can't confirm that from our product info. Send it to our team and we'll email you the answer.",
          label: 'Ask our team',
        });
        try {
          const response = await fetch(this.dataset.url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ question, product: this.dataset.product, context: this.context() }),
          });
          const { status, answer, source } = await response.json();
          if (status === 'answered') {
            this.show({ text: answer, source: source === 'None' ? '' : SOURCE_PREFIX + source });
          } else if (status === 'order_issue') {
            this.show({ text: answer, contact: true, team: false });
          } else {
            this.show(noAnswer(answer));
          }
        } catch {
          this.show(noAnswer());
        }
        this.send.disabled = false;
      }

      openTeamForm() {
        this.dialog.close();
        document.querySelector('ym-reviews')?.openQuestionForm(this.question);
      }
    }
  );
}
